/**
 * Progresso simulado de um envio em massa (previa).
 *
 * Enquanto houver item "em andamento", um unico `setInterval` avanca cada um
 * a cada tique e grava o ajuste via `aplicarAjuste`. Deterministico: o passo e
 * uma fracao do total e as falhas entram em tiques fixos (sem Math.random).
 *
 * Os itens ficam num `ref` atualizado a cada render para o tique ler sempre a
 * lista mais recente sem reiniciar o intervalo -- reiniciar a cada render
 * faria a barra travar enquanto a pessoa digita no formulario ao lado.
 */

import { useEffect, useRef } from 'react';

export const TIQUE_MS = 900;

export function useProgressoSimulado<T extends { readonly id: string }>(
  itens: readonly T[],
  emAndamento: (item: T) => boolean,
  avancar: (item: T, tique: number) => Partial<T>,
  aplicarAjuste: (id: string, patch: Partial<T>) => void,
): void {
  const itensRef = useRef(itens);
  itensRef.current = itens;
  const avancarRef = useRef(avancar);
  avancarRef.current = avancar;
  const tiqueRef = useRef(0);

  const ativo = itens.some(emAndamento);

  useEffect(() => {
    if (!ativo) {
      return undefined;
    }
    const timer = window.setInterval(() => {
      tiqueRef.current += 1;
      for (const item of itensRef.current) {
        if (emAndamento(item)) {
          aplicarAjuste(item.id, avancarRef.current(item, tiqueRef.current));
        }
      }
    }, TIQUE_MS);
    return () => {
      window.clearInterval(timer);
    };
  }, [ativo, emAndamento, aplicarAjuste]);
}
